import Api from "~/utils/Api"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

export interface WeekStats {
  [userId: string]: {
    week_timers: number
    today_timers: number | null
  }
}

export const useWeekStats = (weekOffset = 0) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryKey: ["weekStats", weekOffset],
    queryFn: () =>
      Api.get("week_stats", { params: { week_offset: weekOffset } }).then(
        (response) => response.data as WeekStats,
      ),
  })
